import { render, staticRenderFns } from "./MenuMobile.vue?vue&type=template&id=65e4e3a1&scoped=true&"
import script from "./MenuMobile.vue?vue&type=script&lang=ts&"
export * from "./MenuMobile.vue?vue&type=script&lang=ts&"
import style0 from "./MenuMobile.vue?vue&type=style&index=0&id=65e4e3a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e4e3a1",
  null
  
)

export default component.exports
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QRouteTab from 'quasar/src/components/tabs/QRouteTab.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTabs,QRouteTab,QSpace,QBtn});
